import { classNames } from '../../utils/style-class.utils';
import { ButtonGroupTypes } from './models/ButtonGroupTypes';
export var buttonTypeWrapper = 'relative z-0 inline-flex gap-2 w-full';
export var chipTypeWrapper = 'relative z-0 inline-flex flex-wrap';
export var chip = function (disabled) {
    return "inline-flex items-center px-4 py-2 rounded-full text-sm font-medium mr-2 mb-4 cursor-pointer ".concat(disabled ? 'bg-uiLight opacity-80' : '');
};
var sharedButtonStyles = function (disabled) {
    return "font-body p-3 text-sm font-medium rounded-10 items-center flex items-center justify-center ".concat(disabled ? 'opacity-50' : '');
};
export var notSelectedChip = 'text-secondary cursor-pointer bg-secondaryAccent2';
export var notSelectedButtonOrChip = 'text-secondary cursor-pointer bg-secondaryAccent2';
export var selected = function (colour) {
    return "z-10 outline-none cursor-pointer text-white bg-".concat(colour);
};
export var getOptionStyle = function (type, disabled) {
    switch (type) {
        case ButtonGroupTypes.Chip:
            return chip(disabled);
        case ButtonGroupTypes.Button:
        default:
            return classNames(sharedButtonStyles(disabled), "w-full");
    }
};
//# sourceMappingURL=button-group.styles.js.map